import { AdministratorModel } from '@/types/models/administrators';
import InputEntity, { PHONE_MASK } from '@/lib/formFactory/inputEntity';
import CheckboxEntity from '@/lib/formFactory/checkboxEntity';
import { CheckboxItem } from '@/lib/formFactory/checkbox.interface';
import MultiselectEntity from '@/lib/formFactory/multiselect/entity';
import SelectEntity from '@/lib/formFactory/select/entity';
import { RoleEnum } from '../user';

export default class EntityModel {
    model: AdministratorModel;

    constructor() {
        const nameEntity = new InputEntity('name');
        nameEntity.setTitle('Имя');
        nameEntity.setRequired(true);

        const patronymicEntity = new InputEntity('patronymic');
        patronymicEntity.setTitle('Отчество');
        patronymicEntity.setRequired(true);

        const surnameEntity = new InputEntity('surname');
        surnameEntity.setTitle('Фамилия');
        surnameEntity.setRequired(true);

        const emailEntity = new InputEntity('email');
        emailEntity.setTitle('Email');
        emailEntity.setRequired(true);

        const checkboxItem: CheckboxItem = {
            id: 1,
            name: 'Активен',
            checked: true,
        };

        const isActiveEntity = new CheckboxEntity('isActive');
        isActiveEntity.setName('Активен');
        isActiveEntity.setList([checkboxItem]);

        const phoneEntity = new InputEntity('phone');
        phoneEntity.setTitle('Телефон');
        phoneEntity.setRequired(true);
        phoneEntity.setMask(PHONE_MASK);

        const roleEntity = new SelectEntity('role');
        roleEntity.setTitle('Роль');
        roleEntity.setRequired(true);
        roleEntity.setList([
            { id: RoleEnum.ROLE_ADMIN, value: 'Администратор' },
            { id: RoleEnum.ROLE_SUPER_ADMIN, value: 'Суперадминистратор' },
        ]);

        const passwordEntity = new InputEntity('password');
        passwordEntity.setTitle('Пароль');

        const passwordConfirmEntity = new InputEntity('password');
        passwordConfirmEntity.setTitle('Подтвердите пароль');

        const clinicsEntity = new MultiselectEntity('clinicsEntity')
            .setTitle('Клиники')
            .setListLoader({
                moduleName: 'clinics/'
            })

        this.model = {
            name: nameEntity.entity[nameEntity.entityName],
            patronymic: patronymicEntity.entity[patronymicEntity.entityName],
            surname: surnameEntity.entity[surnameEntity.entityName],
            email: emailEntity.entity[emailEntity.entityName],
            is_active: isActiveEntity.entity,
            phone: phoneEntity.entity[phoneEntity.entityName],
            role: roleEntity.entity,
            password: passwordEntity.entity[passwordEntity.entityName],
            passwordConfirm: passwordConfirmEntity.entity[passwordConfirmEntity.entityName],
            clinics: clinicsEntity.entity,
        };
    }
}
